export const handleJsonResponse = (request: Promise<Response>) => {
  return request.then(response => {
    if (!response.ok) {
      return Promise.reject(response);
    }
    return response.json();
  });
};